<div class="form-container">
  @switch (formType) {
    @case (StitchType.MESSAGE_FOLDER) {
      <app-message-folder-form
        *appMailAppContext
        id="message-folder-form-dp"
        [folder]="messageFolder"
        [requestContext]="requestContext"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.MESSAGE) {
      <app-message2-form
        *appMailAppContext
        id="message2-form-dp"
        (close)="handleCancel($event)"
        (back)="handleBack()"
        [message]="message"
        [requestContext]="requestContext"
        [autoSaveAllowed]="false"
        [tab]="preSelectedTab"
        [dp]="true"
        [openedFromHub]="openedFromHub"
      />
    }
    @case (StitchType.CALENDAR) {
      <app-calendar-form
        *appCalendarAppContext
        id="calendar-form-dp"
        [calendar]="calendar"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.EVENT) {
      <app-event-form
        *appCalendarAppContext
        id="event-form-dp"
        [event]="event"
        [tab]="preSelectedTab"
        [dp]="true"
        [openedFromHub]="openedFromHub"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.PROJECT) {
      <app-project-form
        *appTaskingAppContext
        id="project-form-dp"
        [project]="project"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.TASK) {
      <app-task-form
        *appTaskingAppContext
        id="task-form-dp"
        [task]="task"
        [tab]="preSelectedTab"
        [dp]="true"
        [openedFromHub]="openedFromHub"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.NOTEBOOK) {
      <app-notebook-form
        *appNotesAppContext
        id="notebook-form-dp"
        [notebook]="notebook"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.NOTE) {
      <app-note-form
        *appNotesAppContext
        id="note-form-dp"
        [note]="note"
        [tab]="preSelectedTab"
        [dp]="true"
        [openedFromHub]="openedFromHub"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.GROUP) {
      <app-group-form
        *appContactsAppContext
        id="group-form-dp"
        [group]="group"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.CONTACT) {
      <app-contact-form
        *appContactsAppContext
        id="contact-form-dp"
        [contact]="contact"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.FOLDER) {
      <app-folder-form
        *appFilesAppContext
        id="folder-form-dp"
        [folder]="folder"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.FILE) {
      <app-file-form
        *appFilesAppContext
        id="file-form-dp"
        [file]="file"
        [tab]="preSelectedTab"
        [dp]="true"
        [openedFromHub]="openedFromHub"
        (close)="handleCancel($event)"
        (back)="handleBack()"
      />
    }
    @case (StitchType.SHEET_FOLDER) {
      <app-sheet-folder-form *appSheetsAppContext
        id="sheet-folder-form-dp"
        [sheetFolder]="sheetFolder"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
        />
    }
    @case (StitchType.SHEET) {
      <app-sheet-form *appSheetsAppContext
        id="sheet-form-dp"
        [sheet]="sheet"
        [tab]="preSelectedTab"
        [dp]="true"
        (close)="handleCancel($event)"
        (back)="handleBack()"
        />
    }
  }
</div>
